import React from 'react'
import { find, sortBy } from 'lodash'

import { load, schemas } from 'api'
import { Button, Link } from 'core'
import { webinarLinkTo } from 'event-taxonomy'

import { SidebarPanel } from '../components/SidebarPanel'

import css from './style.scss'

/**
 * A compact sidebar summary rather than the dashboard's CoreCurriculumBlock,
 * whose two-column card grid is built for full width and breaks in a 355px
 * column. Fetches its own data — safe inside a block because PageBlockRenderer
 * is already connected to the store.
 */
export const CoreCurriculumProgress = ({ header, cta_label: ctaLabel, cta_url: ctaUrl, coreCurriculum, loadStatus }) => {
  if (loadStatus.coreCurriculum.loading || !coreCurriculum || !coreCurriculum.length) {
    return null
  }

  // Derived, never hardcoded — the curriculum length is not a fixed 10.
  const total = coreCurriculum.length
  const completed = coreCurriculum.filter(item => item.is_completed).length
  const percent = Math.round((completed / total) * 100)
  const nextUp = find(sortBy(coreCurriculum, 'position'), item => !item.is_completed)

  return (
    <SidebarPanel header={header || 'Core Curriculum'}>
      <p className={css.progressCount}>
        <strong>{completed}</strong> of <strong>{total}</strong> complete
      </p>

      <div
        className={css.progressTrack}
        role='progressbar'
        aria-valuenow={completed}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-label={`Core curriculum progress: ${completed} of ${total} complete`}
      >
        <div className={css.progressBar} style={{ width: `${percent}%` }} />
      </div>

      {nextUp && nextUp.webinar && (
        <p className={css.nextUp}>
          <span className={css.nextUpLabel}>Next up</span>
          <Link to={webinarLinkTo(nextUp.webinar)} target='_blank'>
            <span className={css.nextUpTitle}>{nextUp.webinar.title}</span>
          </Link>
        </p>
      )}

      <Link to={ctaUrl || '/core-curriculum'}>
        <Button size='tertiary' noMargin>{ctaLabel || 'View Core Curriculum'}</Button>
      </Link>
    </SidebarPanel>
  )
}

CoreCurriculumProgress.propTypes = {
  header: React.PropTypes.string,
  cta_label: React.PropTypes.string,
  cta_url: React.PropTypes.string,
  coreCurriculum: React.PropTypes.array,
  loadStatus: React.PropTypes.object.isRequired
}

export default load({
  coreCurriculum: {
    urlSelector: () => '/v2/core_curriculum',
    schema: [schemas.coreCurriculumWebinar]
  }
})(CoreCurriculumProgress)
